import { Button, Input } from "@heroui/react";
import { TempAgreement } from "@/api/temp-agreements/temp-agreements";
import { S3_URL } from "@/api";
import { FaFile } from "react-icons/fa6";

interface AgreementDetailsFormProps {
  data: TempAgreement;
  onSubmit: () => void;
}

export function AgreementDetailsForm({
  data,
  onSubmit,
}: AgreementDetailsFormProps) {
  const handleSubmit = () => {
    onSubmit();
  };

  return (
    <div className="w-full max-w-2xl space-y-4 p-6 bg-background rounded-xl border-2 border-foreground-200 dark:border-foreground-100">
      <div className="grid grid-cols-2 gap-4">
        <Input
          label="Цена"
          variant="bordered"
          value={data.price?.toString() || ""}
          isReadOnly
        />
        <Input
          label="Дата начала"
          variant="bordered"
          value={data.start_date || ""}
          isReadOnly
        />
      </div>
      <div className="grid grid-cols-2 gap-4">
        <Input
          label="Дата окончания"
          variant="bordered"
          value={data.end_date || ""}
          isReadOnly
        />
      </div>
      <div className="w-full flex gap-2">
        <a
          href={`${S3_URL}/${data.scan}`}
          target="_blank"
          rel="noopener noreferrer"
        >
          <Button color="success" variant="bordered" startContent={<FaFile />}>
            Просмотреть договор
          </Button>
        </a>
        <Button onClick={handleSubmit} color="success">
          Подтвердить
        </Button>
      </div>
    </div>
  );
}
